/* Penoblo Hero „Silber" (Fullwidth).
   Full-Bleed-Slideshow: Crossfade + Ken-Burns, Autoplay mit Fortschritts-Dots,
   Prev/Next/Play-Pause, Hover-Pause, Tastatur (←/→/Leertaste). Slides werden
   serverseitig (Liquid-Bloecke) gerendert; dieses Element verdrahtet nur. */
class PnbHero extends HTMLElement {
  connectedCallback() {
    this.hero = this.querySelector('.hero');
    this.slides = [...this.querySelectorAll('.hslide')];
    this.dots = [...this.querySelectorAll('.dot')];
    this.nowLabel = this.querySelector('[data-now]');
    this.total = this.slides.length;
    if (!this.total) return;

    this.dur = parseInt(this.dataset.dur || '6500', 10);
    this.hero.style.setProperty('--dur', this.dur + 'ms');
    this.cur = Math.max(0, this.slides.findIndex((s) => s.classList.contains('on')));
    if (this.cur < 0) this.cur = 0;
    this.paused = false;
    this.timer = null;
    // Bewegungsempfindliche Nutzer: keine automatische Slide-Rotation (manuelle
    // Navigation via Pfeile/Dots bleibt moeglich). Gate in schedule() -> greift
    // auch fuer mouseleave/restart.
    this._reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Alle Listener an ein AbortController-Signal haengen -> disconnectedCallback
    // raeumt sie (inkl. window-resize) bei shopify:section:unload sauber ab.
    const signal = (this._ac = new AbortController()).signal;

    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    const play = this.querySelector('[data-play]');
    this.playBtn = play;

    this.dots.forEach((d, i) => d.addEventListener('click', () => { this.go(i); this.restart(); }, { signal }));
    if (next) next.addEventListener('click', () => { this.next(); this.restart(); }, { signal });
    if (prev) prev.addEventListener('click', () => { this.prev(); this.restart(); }, { signal });
    if (play) play.addEventListener('click', () => this.setPaused(!this.paused), { signal });

    this.hero.addEventListener('mouseenter', () => {
      if (!this.paused) { clearTimeout(this.timer); this.dots.forEach((d) => d.classList.add('paused')); }
    }, { signal });
    this.hero.addEventListener('mouseleave', () => {
      if (!this.paused) { this.schedule(); this.dots.forEach((d) => d.classList.remove('paused')); }
    }, { signal });

    this.hero.setAttribute('tabindex', '0');
    this.hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { this.next(); this.restart(); }
      else if (e.key === 'ArrowLeft') { this.prev(); this.restart(); }
      else if (e.key === ' ') { e.preventDefault(); this.setPaused(!this.paused); }
    }, { signal });

    this.videos = [...this.querySelectorAll('.hslide__media')];
    if (this.videos.length) {
      window.addEventListener('resize', () => this.syncVideos(), { signal });
    }

    this.syncLabel(true);
    this.syncVideos();
    if (this.total > 1) this.schedule();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    if (this._ac) this._ac.abort();
  }

  /* nur das sichtbare (Breakpoint) Video der aktiven Folie abspielen */
  syncVideos() {
    if (!this.videos || !this.videos.length) return;
    this.videos.forEach((v) => {
      if (typeof v.play !== 'function') return;
      const slide = v.closest('.hslide');
      const active = slide && slide.classList.contains('on');
      const visible = v.offsetParent !== null; // nicht display:none
      const noAuto = (this._reduce && !this._userPlayed) || this.paused;
      if (active && visible && !noAuto) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      else { v.pause(); }
    });
  }

  go(i) {
    this.cur = (i + this.total) % this.total;
    this.slides.forEach((el, k) => el.classList.toggle('on', k === this.cur));
    this.dots.forEach((d, k) => {
      d.classList.toggle('active', k === this.cur);
      if (k === this.cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      d.classList.toggle('paused', this.paused);
      if (k === this.cur) {
        const f = d.querySelector('.dot__fill');
        if (f) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
      }
    });
    this.syncLabel(false);
    this.syncVideos();
  }

  syncLabel(initial) {
    if (!this.nowLabel) return;
    const label = this.slides[this.cur] ? this.slides[this.cur].dataset.label || '' : '';
    if (initial) { this.nowLabel.textContent = label; return; }
    this.nowLabel.style.opacity = '0';
    setTimeout(() => { this.nowLabel.textContent = label; this.nowLabel.style.opacity = '1'; }, 160);
  }

  next() { this.go(this.cur + 1); }
  prev() { this.go(this.cur - 1); }
  schedule() { clearTimeout(this.timer); if (!this.paused && !this._reduce && this.total > 1) this.timer = setTimeout(() => { this.next(); this.schedule(); }, this.dur); }
  restart() { this.schedule(); }

  setPaused(p) {
    this.paused = p;
    if (!p) this._userPlayed = true;
    this.hero.classList.toggle('is-paused', p);
    if (this.playBtn) {
      const ds = this.playBtn.dataset;
      this.playBtn.setAttribute('aria-label', p ? (ds.labelPlay || 'Slideshow abspielen') : (ds.labelPause || 'Slideshow pausieren'));
    }
    this.dots.forEach((d) => d.classList.toggle('paused', p));
    if (p) clearTimeout(this.timer); else this.schedule();
    this.syncVideos();
  }
}
if (!customElements.get('pnb-hero')) customElements.define('pnb-hero', PnbHero);
